function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M14.8,47.2c-1.1,0-1.9-.9-1.9-1.9V14.8c0-1.1.9-1.9,1.9-1.9h30.5c1.1,0,1.9.9,1.9,1.9v13h3v-13c0-2.7-2.2-4.9-4.9-4.9H14.8c-2.7,0-4.9,2.2-4.9,4.9v30.5c0,2.7,2.2,4.9,4.9,4.9h13v-3h-13Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M65.2,29.8h-30.5c-2.7,0-4.9,2.2-4.9,4.9v30.5c0,2.7,2.2,4.9,4.9,4.9h30.5c2.7,0,4.9-2.2,4.9-4.9v-30.5c0-2.7-2.2-4.9-4.9-4.9M32.8,34.7c0-1.1.9-1.9,1.9-1.9h30.5c1.1,0,1.9.9,1.9,1.9v30.5c0,1.1-.9,1.9-1.9,1.9h-30.5c-1.1,0-1.9-.9-1.9-1.9v-30.5Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M21.5,18.6c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9,2.9-1.3,2.9-2.9h0c0-1.6-1.3-2.9-2.9-2.9"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M21.5,35.7c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9,2.9-1.3,2.9-2.9h0c0-1.6-1.3-2.9-2.9-2.9"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M35.7,21.5c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9-1.3-2.9-2.9-2.9h0c-1.6,0-2.9,1.3-2.9,2.9"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M41.4,44.3c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9-2.9,1.3-2.9,2.9h0c0,1.6,1.3,2.9,2.9,2.9"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M41.4,61.4c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9-2.9,1.3-2.9,2.9h0c0,1.6,1.3,2.9,2.9,2.9"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M50,52.8c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9-2.9,1.3-2.9,2.9h0c0,1.6,1.3,2.9,2.9,2.9"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M58.5,44.3c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9-2.9,1.3-2.9,2.9h0c0,1.6,1.3,2.9,2.9,2.9"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M58.5,61.4c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9-2.9,1.3-2.9,2.9h0c0,1.6,1.3,2.9,2.9,2.9"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

export default __webpack_public_path__ + "static/media/InstantWin-inactive.2319fef1.svg";
export { SvgComponent as ReactComponent };